import { Injectable, Inject } from '@angular/core';
import * as Keycloak_ from 'keycloak-js';
const Keycloak = Keycloak_;
import { LUMILOGIN_URL, LUMILOGIN_CLIENTID, LUMILOGIN_REALM, LUMILOGIN_SECRET } from '../lumilogin.token';
import { Observable } from 'rxjs';

// @dynamic
@Injectable({
	providedIn: 'root'
})
export class LumiloginService {

	static auth: any = {};

	private static url: string = "";
	private static realm: string = "";
	private static clientId: string = "";
	private static secret: string = "";

	private _searchObservable: Observable<string>;

	constructor(@Inject(LUMILOGIN_URL) private url: string,
		@Inject(LUMILOGIN_REALM) private realm: string,
		@Inject(LUMILOGIN_CLIENTID) private clientId: string,
		@Inject(LUMILOGIN_SECRET) private secret: string) {
		LumiloginService.url = url;
		LumiloginService.realm = realm;
		LumiloginService.clientId = clientId;
		LumiloginService.secret = secret;
	}

	static init(): Promise<any> {

		const keycloakAuth: Keycloak.KeycloakInstance = Keycloak({
			url: this.url,
			realm: this.realm,
			clientId: this.clientId,
			secret: this.secret,
			'ssl-required': 'external',
			'public-client': true
		});
		LumiloginService.auth.loggedIn = false;

		return new Promise((resolve, reject) => {
			keycloakAuth.init({ onLoad: 'login-required', checkLoginIframe: false })
				.success(() => {
					LumiloginService.auth.loggedIn = false;
					LumiloginService.auth.authz = keycloakAuth;
					resolve();
				})
				.error(() => {
					reject();
				});
		});
	}

	login(): void {
		LumiloginService.auth.authz.login().success(
			() => {
				LumiloginService.auth.loggedIn = true;
			}
		);
	}

	getToken(): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			if (LumiloginService.auth.authz.token) {
				LumiloginService.auth.authz
					.updateToken(5)
					.success(() => {
						resolve(<string>LumiloginService.auth.authz.token);
					})
					.error(() => {
						reject('Failed to refresh token');
					});
			} else {
				reject('Not logged in');
			}
		});
	}

	isLoggedIn(): boolean {
		return LumiloginService.auth.authz.authenticated;
	}

	getFullName(): string {
		let tokenParsed = LumiloginService.auth.authz.tokenParsed;
		return tokenParsed.name || tokenParsed.preferred_username;
	}

	getParsedToken(): any {
		return LumiloginService.auth.authz.tokenParsed;
	}

	getUserId(): string {
		return LumiloginService.auth.authz.tokenParsed.sub;
	}

	getRoles(): string[] {
		return LumiloginService.auth.authz.tokenParsed.resource_access.lumiplay_api.roles;
	}

	getGroups(): any[] {
		return LumiloginService.auth.authz.tokenParsed.group;
	}

	getCompanyName() {
		return LumiloginService.auth.authz.tokenParsed.company;
	}

	getApplications() {
		return LumiloginService.auth.authz.tokenParsed.application || [];
	}

	getKeycloakAuth() {
		return LumiloginService.auth.authz;
	}

	logout(): void {
		LumiloginService.auth.authz.logout({ redirectUri: document.baseURI }).success(() => {
			LumiloginService.auth.loggedIn = false;
			LumiloginService.auth.authz = null;
		});
	}

	get searchObservable(): Observable<string> {
		return this._searchObservable;
	}

	set searchObservable(searchObservable: Observable<string>) {
		this._searchObservable = searchObservable;
	}
}
